/**
 * The two roles every organization is created with, named the same way the server names them
 * (`BuiltInRole` there, `SystemRole` in the ILM app).
 *
 * One declaration rather than one per consumer: the entitlement fetch and the membership rule both
 * turn on the Lite name, and two copies could drift into disagreeing about the same role.
 */
export const LITE_ROLE_NAME = 'Lite'
export const DEFAULT_ROLE_NAME = 'Default'
